import TagManager from 'react-gtm-module'
import { useCookies } from 'react-cookie'
import ynToBool from 'Utils/ynToBool'
import { GTM_CONTAINER_DEFAULT } from 'Constants/Constants'

let TagManagerInitialize = false
const TagManagerWidget = () => {
  if ( TagManagerInitialize ) return ''
  const [cookies] = useCookies(['zoly_consent'])
  if ((cookies && cookies.zoly_consent && cookies.zoly_consent.publicity === true) || !ynToBool(process.env.REACT_APP_LGPD_CONSENT)) {
    TagManagerInitialize = true;
    const tagManagerArgs = {
      gtmId: process.env.REACT_APP_GTM_CONTAINER || GTM_CONTAINER_DEFAULT,
      gtmParams: {
        cookie_flags: 'max-age=7200;secure;samesite=none',
      },
    }
    TagManager.initialize(tagManagerArgs)
  }
  return ''
}

export default TagManagerWidget
